import script from "./MemoryInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MemoryInfo.vue?vue&type=script&setup=true&lang=js"

import "./MemoryInfo.vue?vue&type=style&index=0&id=458de6a3&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-458de6a3"]])

export default __exports__